import React from 'react';
import FilterSupplement from './components/FilterSupplement';
import useSupplementsData from './hooks/useSupplementsData';

const Supplements = () => {
    const { data, loading, error } = useSupplementsData();

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error loading supplements</div>;

    return (
        <div>
            <FilterSupplement />
        </div>
    );
};

export default Supplements;
